import { JobStatus, JobStatusType, JobRunStatusType } from '@/types/job'
import { cn } from '@/lib/utils'

const statusText: Record<JobStatusType, string> = {
  [JobStatus.PENDING]: 'Pending',
  [JobStatus.RUNNING]: 'Running',
  [JobStatus.ERROR]: 'Error',
  [JobStatus.SUCCESS]: 'Success',
}

const baseStyles =
  'w-fit inline rounded-lg py-1 px-3 text-center text-sm font-medium'

const statusColors: Record<JobStatusType, { textClass: string; bgClass: string }> = {
  [JobStatus.PENDING]: { textClass: 'text-gray-700 dark:text-gray-300', bgClass: 'bg-gray-100 dark:bg-dark-accent' },
  [JobStatus.RUNNING]: { textClass: 'text-blue-700 dark:text-blue-400', bgClass: 'bg-blue-100 dark:bg-blue-900/30' },
  [JobStatus.ERROR]: { textClass: 'text-red-700 dark:text-red-400', bgClass: 'bg-red-100 dark:bg-red-900/30' },
  [JobStatus.SUCCESS]: { textClass: 'text-green-700 dark:text-green-400', bgClass: 'bg-green-100 dark:bg-green-900/30' },
}

type JobStatusTagProps = {
  status: JobStatusType
}

export const JobStatusTag = ({ status }: JobStatusTagProps) => {
  const { textClass, bgClass } = statusColors[status]
  return (
    <span className={cn(baseStyles, textClass, bgClass)}>
      {statusText[status]}
    </span>
  )
}

export const JobRunStatusTag = ({ status }: { status: JobRunStatusType }) => {
  const { textClass, bgClass } = statusColors[status as JobStatusType]
  return (
    <span className={cn(baseStyles, textClass, bgClass)}>
      {statusText[status]}
    </span>
  )
}